import { ChakraProvider } from '@chakra-ui/react';
import type { ReactNode } from 'react';
import { system } from './theme';

/** Wraps the app in the shared Figma-native Chakra system. */
export function UiProvider({ children }: { children: ReactNode }) {
  return <ChakraProvider value={system}>{children}</ChakraProvider>;
}
